<ul>
  <li *ngFor="let item of items">
    <h3>{{ item.title }}</h3>
    <p>{{ item.data | number }}</p>
  </li>
</ul>
